import { useState } from 'react'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { Alert, AlertType } from 'components/Alert/Alert'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import useModalClose from 'hooks/useModalClose'
import { Button, ColorVariant, CursorPointer, Flex } from 'styling/GlobalStyles'
import { OtherText, TitleText } from 'styling/Typography'

interface IProps {
  title: string
  description?: string
  locked: boolean
  closeModal: () => void
  onConfirm: (reason: string) => void
}

export const CancelMealModal = ({ title, description, locked, closeModal, onConfirm }: IProps) => {
  const [reason, setReason] = useState('')
  useModalClose(closeModal)

  return (
    <Modal black width='480px'>
      <Flex column gap='1rem' width='100%'>
        <Flex between width='100%' center>
          <TitleText weight='bold'>{title}</TitleText>
          <CursorPointer onClick={closeModal}>
            <CloseIcon />
          </CursorPointer>
        </Flex>
        {description && <OtherText grey>{description}</OtherText>}
        {locked ? (
          <Alert
            title='Cut-off has passed'
            description='Ordered counts will NOT decrease — these meals are in production. Each cancellation is logged as expected waste.'
            type={AlertType.WARNING}
            colorVariant={ColorVariant.PRIMARY}
          />
        ) : (
          <Alert
            title='Before cut-off'
            description='Intents are superseded and the plan adjusts cleanly — no waste.'
            type={AlertType.INFO}
            colorVariant={ColorVariant.SECONDARY}
          />
        )}
        <Input
          type='textarea'
          labelText='Reason'
          required
          value={reason}
          onChange={(e: any) => setReason(e.target.value)}
          placeholder='Please provide a reason…'
          nomarg
        />
        <Flex gap='0.5rem' justcenter width='100%'>
          <Button onClick={closeModal}>Cancel</Button>
          <Button orange disabled={!reason.trim()} onClick={() => onConfirm(reason)}>
            Confirm
          </Button>
        </Flex>
      </Flex>
    </Modal>
  )
}
